import notificationMiddleware from "./notification"
import apiMiddleware from "./api"


export default function getCoreMiddleware() {
  return [
    notificationMiddleware,
    apiMiddleware
  ]
}